import * as React from 'react';

import * as styles from './BannerTgbOffer.css';

type BannerTgbOfferProps = {
  image: string;
  title: string;
  description: string;
  phone: string | undefined;
  footnote: string | undefined;
  url: string;
  label: string | undefined;
};

export const BannerTgbOffer: React.FC<BannerTgbOfferProps> = props => {
  const { image, title, description, phone, footnote, url, label } = props;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer nofollow" className={styles['container']}>
      <div className={styles['image']} style={{ backgroundImage: `url(${image})` }}>
        {label && <div className={styles['label']}>{label}</div>}
      </div>
      <div className={styles['content']}>
        <h4 className={styles['title']}>{title}</h4>
        <p className={styles['description']}>{description}</p>
        {phone && <div className={styles['phone']}>{phone}</div>}
        {footnote && <div className={styles['footnote']}>{footnote}</div>}
      </div>
    </a>
  );
};
